import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import { AppShell } from "@/components/app-shell";
import { TutorPage } from "@/components/tutor/tutor-page";
import { requireRole } from "@/lib/session";

export const Route = createFileRoute("/parent/tutor")({
  ssr: false,
  beforeLoad: () => requireRole("parent"),
  head: () => ({ meta: [{ title: "MAKAI Tutor · MAKAI Parents" }] }),
  component: Page,
});

function Page() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const isThreadRoute = pathname.startsWith("/parent/tutor/");

  if (isThreadRoute) return <Outlet />;

  return (
    <AppShell role="parent" title="MAKAI Tutor" subtitle="Insights & support for your child's journey">
      <TutorPage role="parent" />
    </AppShell>
  );
}
